import { FC } from 'react'
import {
    Outlet
} from "react-router-dom";


const Product: FC = () => {  
    return (
        <Outlet />
    );
}

export default Product